





















import { Component, Prop, Vue, namespace } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { filterPrice } from '~/assets/filters/price'
const siteStore = namespace('site')
@Component({
  filters: {
    filterPrice,
  },
})
export default class ComponentPrice extends Vue {
  @Prop({ type: Number, default: 0 }) private finalPrice!: number
  @Prop({ type: Number, default: 0 }) private price!: number
  @Prop({ type: String, default: '1' }) private typeBlock!: string
  @Prop({ type: String, default: null }) readonly unit!: string
  @Prop({ type: String, default: null }) private prefix!: string

  @siteStore.Getter('getOptionsCurrency') private getOptionsCurrency!: string

  private $style!: IStyle

  private get classPrice() {
    return {
      [this.$style.price]: true,
      [this.$style.typeBlock1]: this.typeBlock === '1',
      [this.$style.typeBlock2]: this.typeBlock === '2',
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private get classFinal() {
    return {
      [this.$style.final]: true,
      [this.$style.typeBlock1]: this.typeBlock === '1',
      [this.$style.hasOld]: this.price > this.finalPrice,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private get classOld() {
    return {
      [this.$style.old]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }
}
